import { Dashboard } from '@apis/index'
import Column from '@components/column'
import GridCard, { IGridItem } from '@components/gridCard'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Fragment } from 'react/jsx-runtime'
import AdminOrderManagement from '../orderManagement'
import AdminUserManagement from '../userManagement'

const AdminDashboard = () => {
  const { data: dashboard } = useSelector((state: any) => state.dashboard)

  const dashboardStats: IGridItem[] = [
    {
      title: 'Total Users',
      value: dashboard?.totalUsers ?? '0',
      IconBg: 'redLight',
      Icon: 'book',
    },
    {
      title: 'Total Subscribed Users',
      value: dashboard?.totalSubscribedUsers ?? '0',
      IconBg: 'greenLight',
      Icon: 'userThree',
    },
    {
      title: 'Total Drivers',
      value: dashboard?.totalDriver ?? '0',
      IconBg: 'yellowLight',
      Icon: 'userThree',
    },
    {
      title: 'Total Payment',
      value: `Rs. ${dashboard?.totalPayment ?? '0'}`,
      IconBg: 'yellowLight',
      Icon: 'moneyBag',
    },
    {
      title: 'Total Books Listed',
      value: dashboard?.totalBook ?? '0',
      IconBg: 'yellowLight',
      Icon: 'book',
    },
    {
      title: 'Pending Books Request',
      value: dashboard?.totalPendingBook ?? '0',
      IconBg: 'redLight',
      Icon: 'book',
    },
    {
      title: 'Total Books Lend',
      value: dashboard?.totalLendBook ?? '0',
      IconBg: 'cyan100',
      Icon: 'book',
    },
    {
      title: 'Total Books Returend',
      value: dashboard?.totalReturnedBook ?? '0',
      IconBg: 'yellowLight',
      Icon: 'book',
    },
  ]
  const fetchDashboard = async () => {
    const params = {
      type: 'dashboard',
    }
    await Dashboard.getAllDashboardCount('dashboard', params).catch(() => {})
  }
  useEffect(() => {
    fetchDashboard()
  }, [])
  return (
    <Fragment>
      <Column rowGap={20}>
        <GridCard items={dashboardStats} />
        <AdminOrderManagement hasStat={false} />
        <AdminUserManagement hasStat={false} />
      </Column>
    </Fragment>
  )
}

export default AdminDashboard
